import { useEffect, useRef } from 'react';
import { usePollingEffect } from '../../utils/customHooks';

const VISIBILITY_CHANGE_EVENT = 'visibilitychange';

const useVisibilityAwarePolling = (asyncCallback, interval, enabled = true) => {
    const callbackRef = useRef(asyncCallback);
    callbackRef.current = asyncCallback;

    const { killPoll, respawnPoll, forceCallback } = usePollingEffect(() => callbackRef.current(), [], { interval });

    useEffect(() => {
        const syncWithVisibility = () => (!enabled || document.hidden ? killPoll() : respawnPoll());
        syncWithVisibility();
        document.addEventListener(VISIBILITY_CHANGE_EVENT, syncWithVisibility);
        return () => {
            document.removeEventListener(VISIBILITY_CHANGE_EVENT, syncWithVisibility);
            killPoll();
        };
    }, [enabled]);

    return { forceFetch: forceCallback };
};

export default useVisibilityAwarePolling;
